@switch (type) {
  @case ('INPUT_PANEL') {
    <label class="input-panel pointer-events-none" [ngClass]="{ 'animate-pulse': pulse }">
      <div class="pt-1">
        <span class="icon flex rounded-full bg-gray-100 visible p-1"><i-tabler aria-hidden="true" class="text-white h-4 w-4" name="check"></i-tabler></span>
        <span aria-hidden="true" class="selection"></span>
      </div>
      <span class="flex-1 grid grid-cols-2">
        <span class="block h-8 bg-gray-100 w-48 rounded-sm"></span>
        <span class="block h-8 bg-gray-100 w-40 ml-auto rounded-sm"></span>
        <span class="mt-2 h-3 mb-0 bg-gray-100 w-32 rounded-sm"></span>
        <span class="mt-2 h-3 mb-0 bg-gray-100 w-32 rounded-sm"></span>
        <span class="">
          <div class="block mt-1 h-3 bg-gray-100 w-60 rounded-sm"></div>
          <div class="block mt-1 h-3 bg-gray-100 w-56 rounded-sm"></div>
        </span>
      </span>
    </label>
  }
  @case ('TEXT_BLOCK') {
    <label class="pointer-events-none" [ngClass]="{ 'animate-pulse': pulse }">
      <span class="flex-1 grid grid-cols-1">
        <span class="mt-2 h-3 mb-0 bg-gray-100 w-full rounded-sm"></span>
        <span class="mt-2 h-3 mb-0 bg-gray-100 w-[80%] rounded-sm"></span>
        <span class="my-2"></span>
        <span class="mt-2 h-3 mb-0 bg-gray-100 w-56 rounded-sm"></span>
      </span>
    </label>
  }
  @default {
    <label class="input-panel items-center pointer-events-none" [ngClass]="{ 'animate-pulse': pulse }">
      <div class="">
        <span class="icon flex rounded-full bg-gray-100 visible p-1"><i-tabler aria-hidden="true" class="text-white h-4 w-4" name="check"></i-tabler></span>
        <span aria-hidden="true" class="selection"></span>
      </div>
      <span class="flex-1 grid grid-cols-2">
        <span class="block h-8 bg-gray-100 w-48 rounded-sm"></span>
        <span class="block h-8 bg-gray-100 w-40 ml-auto rounded-sm"></span>
      </span>
    </label>
  }
}
